import { useUserData } from 'hooks/use-user-data';
import { useEffect, useState } from 'react';

export interface UserInformationForm {
  firstName: string;
  lastName: string;
  email: string;
  language: string;
}

const useSettingsForm = () => {
  const { firstName, lastName, email, language } = useUserData();

  const [userInfo, setUserInfo] = useState<UserInformationForm>({
    firstName: '',
    lastName: '',
    email: '',
    language: '',
  });

  useEffect(() => {
    const initForm: UserInformationForm = { firstName, lastName, email, language };
    setUserInfo(initForm);
  }, [firstName, lastName, email, language]);

  const onUserInfoChange = (field: keyof UserInformationForm) => {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      const updateUserInfo = { ...userInfo };
      updateUserInfo[field] = event.target.value;
      setUserInfo(updateUserInfo);
    };
  };

  return { firstName: userInfo.firstName, lastName: userInfo.lastName, email: userInfo.email, language: userInfo.language, onUserInfoChange };
};

export default useSettingsForm;
